import { ISubscriptionItem } from './../../../../../../store/models/register.model';
import { RegisterService } from './../../../../../../store/services/register.service';
import { Subscription } from 'rxjs';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';

import {
  ISubscriptionsResult,
  RegisterForm,
  RegisterFormPay,
} from '../../../../../../store/models/register.model';
import { Store } from '@ngrx/store';
import { PageState } from '../../../../../../store/models/page.model';
import { setBannerComponent } from '../../../../../../store/actions/page.action';
import { InputTooltipOptions } from 'app/store/models/popover.model';
import { ISelectItem } from 'app/store/models/select.model';

@Component({
  selector: 'app-register-step-pay',
  templateUrl: './register-step-pay.component.html',
  styleUrls: ['./register-step-pay.component.scss'],
})
export class RegisterStepPayComponent implements OnInit, OnDestroy {
  @Input() paymentErrors: any = {};

  @Input() preFilledPayData: RegisterFormPay;

  @Output() Submit: EventEmitter<RegisterForm> =
    new EventEmitter<RegisterForm>();

  registerForm: FormGroup;

  inputTooltipOptions: InputTooltipOptions = {
    text: 'Card Identification Number(CID)',
  };

  currentValidTeamCode: ISubscriptionItem;

  noTeamCodeCharge = '249';

  months: ISelectItem[] = [];

  currentMonth: number;

  years: ISelectItem[] = [];
  currentYear: number;

  private teamCodeSubscribed: Subscription;

  constructor(
    private store: Store<PageState>,
    private registerService: RegisterService
  ) {
    this.store.dispatch(setBannerComponent({ banner: 'Payment' }));
  }

  get plan_amount() {
    return this.registerForm.get('plan_amount');
  }

  get amount() {
    return this.registerForm.get('amount');
  }

  get team_code() {
    return this.registerForm.get('team_code');
  }

  get card_id() {
    return this.registerForm.get('card_id');
  }

  get expire_year() {
    return this.registerForm.get('expire_year');
  }

  get expire_month() {
    return this.registerForm.get('expire_month');
  }

  get card_number() {
    return this.registerForm.get('card_number');
  }

  get card_name() {
    return this.registerForm.get('card_name');
  }

  submitForm = () => {
    if (this.registerForm.valid) {
      this.Submit.emit(this.registerForm.getRawValue());
    } else {
      this.registerForm.markAllAsTouched();
    }
  };

  getMonths() {
    return moment.months();
  }

  getYears() {
    const currentYear = moment().year();
    const result = [currentYear];
    for (let i = currentYear; i < currentYear + 16; i++) {
      result.push(i);
    }

    return result;
  }

  ngOnDestroy(): void {
    if (this.teamCodeSubscribed) {
      this.teamCodeSubscribed.unsubscribe();
    }
  }

  getPreFilledData(property) {
    if (!this.preFilledPayData) {
      return null;
    }

    return this.preFilledPayData.hasOwnProperty(property)
      ? this.preFilledPayData[property]
      : null;
  }

  ngOnInit() {
    window.scroll(0, 0);
    const months = this.getMonths();
    for (let i = 0; i < months.length; i++) {
      this.months.push({
        label: months[i],
        value: i + 1,
      });
    }
    this.currentMonth = moment().month() + 1;

    const years = this.getYears();
    for (const item of years) {
      this.years.push({
        label: item.toString(),
        value: item,
      });
    }
    this.currentYear = moment().year();
    this.registerForm = new FormGroup({
      card_name: new FormControl(this.getPreFilledData('card_name') || '', [
        Validators.required,
      ]),
      card_number: new FormControl(this.getPreFilledData('card_number') || '', [
        Validators.required,
      ]),
      expire_month: new FormControl(
        this.getPreFilledData('expire_month') || moment().month() + 1,
        [Validators.required]
      ),
      expire_year: new FormControl(
        this.getPreFilledData('expire_year') || moment().year(),
        [Validators.required]
      ),
      card_id: new FormControl(this.getPreFilledData('card_id') || '', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(3),
        Validators.pattern(/^[0-9]*$/),
      ]),
      team_code: new FormControl(this.getPreFilledData('team_code') || ''),
      amount: new FormControl('$' + this.noTeamCodeCharge),
      plan_amount: new FormControl(),
      email: new FormControl(localStorage.getItem('email')),
    });

    this.teamCodeSubscribed = this.team_code.valueChanges.subscribe(res =>
      this.onTeamCodeChanges(res)
    );
  }

  onTeamCodeChanges(value: string) {
    if (value.length < 3) {
      return;
    }

    const res = this.registerService.getPlanByTeamCode(value);

    res.subscribe((result: ISubscriptionsResult) => {
      if (
        result &&
        result.total_count === 1 &&
        result.items.length === 1 &&
        result.items[0].team_code === value
      ) {
        this.currentValidTeamCode = result.items[0];
        this.amount.setValue('$' + result.items[0].subscription_cost);
        this.plan_amount.setValue('$' + result.items[0].plan_cost);
      } else {
        this.amount.setValue('$' + this.noTeamCodeCharge);
      }
    });
  }
}
